import { TagManagerIndex, TagManagerViewer } from "../views";

export const tagManagerRouter = {
  main: [
    {
      name: "TagManagerIndex",
      path: "tag-manager",
      component: TagManagerIndex
    }
  ],
  viewer: [
    {
      name: "TagManagerViewer",
      path: "tag-manager",
      component: TagManagerViewer
    }
  ]
};
